// Shared UI primitive (reused across all dashboard pages) — MIS-809.
//
// A minimal text input: plain Tailwind + `cn()`, `forwardRef` so react-hook-form
// `register()` (and native focus) can attach a ref. No wrapper logic — labels and
// error text are composed by the caller (see Label.tsx).

import { forwardRef } from 'react';
import { cn } from '@/lib/utils';

export type InputProps = React.InputHTMLAttributes<HTMLInputElement>;

export const Input = forwardRef<HTMLInputElement, InputProps>(({ className, ...props }, ref) => (
  <input
    ref={ref}
    className={cn(
      'flex h-9 w-full rounded-md border border-[var(--border-soft)] bg-[var(--surface-2)] px-3 py-1 text-sm text-[var(--text)]',
      'placeholder:text-[var(--muted-2)] focus-visible:border-[var(--accent)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--accent)]',
      'disabled:cursor-not-allowed disabled:opacity-50',
      className,
    )}
    {...props}
  />
));
Input.displayName = 'Input';
